import { tm } from '../tm'
import i18n from './i18n'
import type { Locales } from '@captaincause/types'

interface ProgressBarProps {
  percent: number
  locale: Locales
  className?: string
}

export const ProgressBar = ({
  percent,
  locale,
  className = '',
}: ProgressBarProps) => {
  let progressWidth: string
  if (percent >= 100) {
    progressWidth = '100%'
  } else if (percent < 0.5) {
    progressWidth = '0%'
  } else if (percent <= 5) {
    progressWidth = '5%'
  } else {
    progressWidth = `${percent}%`
  }

  return (
    <div
      className={tm('flex w-full flex-col items-start space-y-2', className)}
    >
      <div className="w-full border-collapse rounded-full border border-medium-gray p-[2px]">
        <div className="h-3 w-full border-collapse rounded-full bg-medium-gray">
          <div
            className="h-3 rounded-full"
            style={{
              width: progressWidth,
              background: 'linear-gradient(270deg, #343FB2 0%, #5965E3 100%)',
            }}
          />
        </div>
      </div>
      <span
        className="text-sm font-normal leading-5 -tracking-[0.14px]"
        style={{ color: '#343FB2' }}
      >
        <span className="font-semibold">{percent.toFixed()}%</span>{' '}
        {i18n[locale].monthly_objective} {percent >= 100 ? '🏆' : '🎯'}
      </span>
    </div>
  )
}
